import React, { useMemo } from "react";
import FieldNoteBlock from "./FieldNoteBlock";

function cleanRichHtml(html) {
  return String(html || "").replace(/<p>(?:\s|&nbsp;|<br\s*\/?\s*>)*<\/p>/gi, "");
}

function splitBody(html) {
  const cleaned = cleanRichHtml(html);
  const regex = /(?:<p[^>]*>)?\s*\[\[FIELDNOTE_BLOCK:([A-Za-z0-9_-]+)\]\]\s*(?:<\/p>)?/gi;
  const parts = []; let last = 0; let match;
  while ((match = regex.exec(cleaned)) !== null) {
    if (match.index > last) parts.push({ type: "html", html: cleaned.slice(last, match.index) });
    parts.push({ type: "block", key: match[1] }); last = regex.lastIndex;
  }
  if (last < cleaned.length) parts.push({ type: "html", html: cleaned.slice(last) });
  return parts;
}

function FieldNoteRichBody({ html, blocks = [] }) {
  const blockMap = useMemo(() => Object.fromEntries((blocks || []).map((b) => [b.block_key, b])), [blocks]);
  return <>{splitBody(html).map((part, i) => part.type === "block" ? <FieldNoteBlock key={`block-${part.key}-${i}`} block={blockMap[part.key]} /> : <div key={`html-${i}`} dangerouslySetInnerHTML={{ __html: part.html }} />)}</>;
}
export { cleanRichHtml };
export default FieldNoteRichBody;
